export const preloadImg = (url: string) => (new Image().src = url);
